<div class="list-container" *ngIf="!isEdit">
    <div class="list-content">
        <div class="list-details">
            <h4 class="list-details-title">Customer Product Price List</h4>
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th scope="col">Customer</th>
                        <th scope="col">Product</th>
                        <th scope="col">Uom</th>
                        <th scope="col">Min Qty</th>
                        <th scope="col">Max Qty</th>
                        <th scope="col">Per Unit Price</th>
                        <th scope="col">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let list of customerProductPriceList | paginate : {
                        itemsPerPage: tableSize,
                        currentPage: pageNumber1,
                        totalItems: totalRecords
                        };let i = index">
                        <td scope="col">{{list.customerName}} ( {{list.customerId}} )</td>
                        <td scope="col">{{list.productName}} ( {{list.productId}} )</td>
                        <td scope="col">{{list.uom}}</td>
                        <td scope="col">{{list.minQty}}</td>
                        <td scope="col">{{list.maxQty}}</td>
                        <td scope="col">{{list.perUnitPrice}}</td>
                        <th scope="col">
                            <span>
                                <i (click)="getCustomerProductPriceByCustomerProductPriceId(list.customerProductPriceId)" class="bi bi-pencil-square"></i>
                            </span>
                        </th>
                    </tr>
                </tbody>
            </table>
            <div class="pagination-block" *ngIf="customerProductPriceList.length != 0">
                <pagination-controls
                    previousLabel="Prev"
                    nextLabel="Next"
                    (pageChange)="onTableDataChange($event)"
                >
                </pagination-controls>
            </div>
        </div>
    </div>
</div>

<div class="list-container" *ngIf="isEdit">
    <div class="list-content">
        <div class="list-details">
            <h4 class="list-details-title">Edit Customer Product Price</h4>
            <div [formGroup]="editCustomerProductPriceForm">
                <div class="row">
                    <div class="col-md-12 col-lg-12">
                        <div class="form-group">
                            <label>Product <span class="required-field">*</span></label>
                            <input readonly formControlName="productName" type="text" class="form-control readonly">


                        </div>
                        <div class="form-group">
                            <label>Customer <span class="required-field">*</span></label>
                            <input readonly formControlName="customerName" type="text" class="form-control readonly">

                        </div>
                        <div class="form-group">
                            <label>UOM <span class="required-field">*</span></label>
                            <input readonly formControlName="uom" type="text" class="form-control readonly">

                        </div>
                        <div class="form-group">
                            <label>Min Qty <span class="required-field">*</span></label>
                            <input formControlName="minQty" type="text" class="form-control">
                            <span class="err" *ngIf="editCustomerProductPriceForm.get('minQty').invalid && formSubmit">min qty required</span>
                        </div>
                        <div class="form-group">
                            <label>Max Qty <span class="required-field">*</span></label>
                            <input formControlName="maxQty" type="text" class="form-control">
                            <span class="err" *ngIf="editCustomerProductPriceForm.get('maxQty').invalid && formSubmit">department name required</span>
                        </div>
                        <div class="form-group">
                            <label>Per Unit Price <span class="required-field">*</span></label>
                            <input formControlName="perUnitPrice" type="text" class="form-control">
                            <span class="err" *ngIf="editCustomerProductPriceForm.get('perUnitPrice').invalid && formSubmit">per unit price required</span>
                        </div>
                    </div>


                    
               
                </div>
            </div>
            <div class="submit-block">
                <button type="button" (click)="editCustomerProductPrice()" class="btn btn-primary">Edit</button>
                <button type="button" (click)="isEdit = false" class="btn btn-secondary">Cancel</button>
            </div>
        </div>
    </div>
</div>